(() => {
  'use strict';
  const resize = (src, width) => {
    if (!src || /_[0-9]+x\.[a-z]+(?:\?|$)/i.test(src)) return src;
    return src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, `_${width}x$1$2`);
  };
  const optimize = (root) => {
    const nodes = [];
    if (root?.matches?.('img.brand-header-logo')) nodes.push(root);
    root?.querySelectorAll?.('img.brand-header-logo').forEach((node) => nodes.push(node));
    nodes.forEach((image) => {
      if (image.dataset.optimizedHero === 'true') return;
      const original = image.getAttribute('src');
      if (!original) return;
      image.dataset.optimizedHero = 'true';
      image.src = resize(original, 480);
      image.srcset = `${resize(original, 320)} 320w, ${resize(original, 480)} 480w, ${resize(original, 640)} 640w`;
      image.sizes = '(max-width: 760px) 220px, 320px';
      image.decoding = 'async';
      image.fetchPriority = 'high';
    });
  };
  const observer = new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(optimize)));
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', () => { optimize(document); observer.disconnect(); }, { once: true });
})();
